import { useState } from "react";
import { useGetUsersQuery } from "../../store/adminUsers/adminUsersApi";
import { GridWrap } from "../ui/wrappers/GridWrap/GridWrap";
import LoadBlock from "../view/LoadBlock/LoadBlock";
import { TextError } from "../ui/errors/TextError/TextError";
import { UserItem } from "../view/UserItem/UserItem";

const PAGE_SIZE = 30;

export const Users = () => {
  const [page, setPage] = useState(1);
  const { data, isLoading, error, refetch } = useGetUsersQuery(
    { page, limit: PAGE_SIZE },
    { refetchOnMountOrArgChange: true },
  );

  return (
    <>
      {isLoading ? (
        <LoadBlock />
      ) : error ? (
        <TextError text="Ошибка при загрузке" />
      ) : (
        <GridWrap column={1}>
          {data && data.items.length > 0
            ? data.items.map((user) => (
                <UserItem
                  key={user.uuid}
                  user={user}
                  onActionComplete={refetch}
                />
              ))
            : null}
        </GridWrap>
      )}
    </>
  );
};
